<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Top",
  components: {
    Header,
    Footer
  },
  props: {
    bgImage: {
      type: String,
      default: require("../assets/first-view-bg.png")
    }
  },
  data() {
    return {};
  }
};
</script>

<template>
  <div class="top">
    <Header />
    <div class="first-view" :style="{ backgroundImage: `url(${bgImage})` }">
      <div class="first-view_row">
        <div class="col-left">
          <div class="messages">
            <h1 class="main-message_text">
              あなたの美容に
              <br />専属アドバイザ
            </h1>
            <p class="sub-message_text">
              好きな時間にあなたの
              <br />キレイを毎日更新
            </p>
          </div>
          <div class="store-btns">
            <a class="header-menus_a" href="https://apple.co/2SW12NV" target="_blank">
              <img class="apple-btn" src="@/assets/apple-button.png" />
            </a>
          </div>
        </div>
        <div class="col-right">
          <img class="mira-app" src="@/assets/mira-app.png" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<style scoped>
.top {
  position: relative;
  background-color: #ffffff;
}
.first-view {
  width: 100%;
  margin-bottom: 96px;
  padding: 148px 0px 96px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.first-view_row {
  display: flex;
  width: 100%;
  max-width: 960px;
  margin: 0px auto;
}
.col-left {
  flex: 2;
}
.col-right {
  flex: 3;
  position: relative;
}
.main-message_text {
  font-size: 48px;
  line-height: 64px;
  color: #ffffff;
  margin-bottom: 24px;
}
.sub-message_text {
  font-size: 28px;
  color: #ffffff;
}
.store-btns {
  margin-top: 32px;
}
.apple-btn {
  display: block;
  width: 160px;
}
.mira-app {
  width: 400px;
  position: absolute;
  top: 0px;
  left: 50%;
  margin-left: -200px;
}

@media screen and (max-width: 768px) {
}
@media screen and (max-width: 480px) {
  .first-view {
    padding: 96px 0px 0px;
  }
  .first-view_row {
    display: block;
    width: 100%;
    padding: 0px 16px;
  }
  .col-left {
    padding-bottom: 48px;
  }
  .col-right {
    height: 295px;
  }
  .main-message_text {
    font-size: 32px;
    text-align: center;
    line-height: 40px;
    margin-bottom: 20px;
  }
  .sub-message_text {
    font-size: 24px;
    text-align: center;
  }
  .apple-btn {
    margin: 0px auto;
  }
  .mira-app {
    width: 280px;
    position: absolute;
    top: 0px;
    margin-right: auto;
    margin-left: auto;
    margin-left: -140px;
  }
}
@media screen and (max-width: 320px) {
}
</style>



// WEBPACK FOOTER //
// src/screens/Top.vue